export const athomHomeyTogetherClientId = '60642aa07d24ec7a951dcb72';
export const athomHomeyTogetherClientSecret = 'gixztcsd4P4rZb0pJ0Rn39U66K5ETFLULH8u3mDq';